import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class OfferMatching {
  constructor($scope, $timeout, OfferService, UiService) {
    $scope.tabs = [{
      title: 'Matched Buyers',
      users: [],
      loading: false,
      checked: false
    }];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
      $scope.query = '';
    };

    $scope.quick_search = function() {
      window.filter_table('table#users', $scope.query);
    };

    $scope.get_matched_buyers = function() {
      var tab = 0;
      $scope.query = '';
      $scope.tabs[tab].users = [];
      $scope.tabs[tab].loading = true;
      $scope.tabs[tab].checked = false;
      $scope.prematching_timing = null;
      OfferService.get_matched_buyers($scope.offer_id, $scope.filter).then(function(data) {
        $scope.matched_buyers = data.users.length;
        $scope.total_buyers = data.total_buyers;
        $scope.tabs[tab].users = data.users;
        $scope.tabs[tab].loading = false;
        $scope.prematching_timing = data.time_elapsed;
      });
    };

    $scope.check_users = function() {
      var tab = $scope.tabs[$scope.selected_tab];
      angular.forEach(tab.users, function(user) {
        user.checked = tab.checked;
      });
    };
    
    $scope.operators = [
      {
        value: 1,
        title: '+'
      },
      {
        value: 2,
        title: '+/-'
      }
    ];
    
    $scope.cuts = [
      {
        value: 1,
        title: '1'
      },
      {
        value: 2,
        title: '2'
      },
      {
        value: 3,
        title: '3'
      },
    ];
    
    $scope.wastes = [
      {
        value: 0,
        title: '0'
      },
      {
        value: 1,
        title: '1'
      },
      {
        value: 2,
        title: '2'
      }
    ];
    
    $scope.ranges = [
      {
        value: 0,
        title: '0'
      },
      {
        value: 1,
        title: '+-0.5'
      },
      {
        value: 2,
        title: '+-1'
      }
    ];

    $scope.get_user_matched_items = function(index) {
      var user = $scope.analysis_users[index];
      OfferService.get_matched_items($scope.offer_id, user.id, $scope.filter, false).then(function(data) {
        console.log(data);
        $scope.analysis_timings.push({
          time: data.time_elapsed,
          user_id: user.id
        });
        user.items = data.items;
        user.items_quantity = window.roundToTwo(_.reduce(_.pluck(data.items, 'quantity'), function(quantity, num) {
          return quantity + num;
        }, 0));
        user.items_quality_accuracy = Math.floor(_.reduce(_.pluck(data.items, 'quality_accuracy'), function(accuracy, num) {
          return accuracy + num;
        }, 0) / data.items.length);
        user.items_specs_accuracy = Math.floor(_.reduce(_.pluck(data.items, 'specs_accuracy'), function(accuracy, num) {
          return accuracy + num;
        }, 0) / data.items.length);
        user.unique_products = _.uniq(_.compact(_.pluck(data.items, 'product_id')));
        user.accurate_items = _.filter(data.items, function(item) {
          return item.specs_accuracy >= 80;
        });
        user.accurate_items_quantity = window.roundToTwo(_.reduce(_.pluck(user.accurate_items, 'quantity'), function(quantity, num) {
          return quantity + num;
        }, 0));
        if (window.is_single_product && data.items.length > 0) {
          user.last_avg_price = data.items[0].last_avg_price;
          user.fca_price_charge = data.items[0].fca_price_charge;
          user.fca_price = data.items[0].fca_price;
          user.cfr_price = data.items[0].cfr_price;
          user.dap_price = data.items[0].dap_price;
        }
        user.price_diff = window.roundToTwo(_.reduce(_.pluck(data.items, 'price_diff'), function(price, num) {
          return price + num;
        }, 0) / data.items.length);
        if (index < $scope.analysis_users.length - 1)
          $scope.get_user_matched_items(index + 1);
      });
    };

    $scope.standard_analysis = function() {
      var tab = $scope.tabs[0];
      $scope.analysis_users = [];
      $scope.analysis_timings = [];
      angular.forEach(tab.users, function(user) {
        if (user.checked) {
          user.items = null;
          user.items_quantity = null;
          user.items_quality_accuracy = null;
          user.items_specs_accuracy = null;
          user.unique_products = null;
          user.accurate_items = null;
          user.accurate_items_quantity = null;
          user.fca_price_charge = null;
          user.fca_price = null;
          user.cfr_price = null;
          user.dap_price = null;
          user.last_avg_price = null;
          user.price_diff = null;
          $scope.analysis_users.push(user);
        }
      });
      if ($scope.analysis_users.length > 0)
        $scope.get_user_matched_items(0);
    };

    $scope.create_users_csv = function() {
      var users = [];
      var tab = $scope.tabs[0];
      angular.forEach(tab.users, function(user) {
        if (user.checked)
          users.push(user);
      });
      if (users.length === 0)
        alert('Please select at least one user!');
      else
        $scope.csv_users = users;
    };

    $scope.$watch('csv_users', function() {
      $timeout(function() {
        if ($scope.csv_users && $scope.csv_users.length > 0)
          $('form#createCSV').submit();
      });
    });

    $scope.get_analysis_url = function(user_id) {
      return '/admin/marketplace/offers/edit_user_pricing/' + window.offer_id + '?user_id=' + user_id;
    };

    $scope.show_send_matching_data = function() {
      var users = _.where($scope.tabs[0].users, {
        checked: true
      });
      if (users.length === 0) {
        alert('Please select at least one user!');
        return false;
      }
      $.fancybox($('div#send_matching_data'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'no',
        afterShow: function() {
          $scope.$broadcast('$tinymce:refresh');
        }
      });
    };

    $scope.send_matching_data = function() {
      if (!$scope.email_recipient)
        return false;
      $scope.sending_matching_data = true;
      $scope.mass_create_xls(null);
    };

    $scope.mass_create_xls = function(index) {
      if (index === null) {
        $scope.xls_users = _.where($scope.tabs[0].users, {
          checked: true
        });
        $scope.mass_create_xls(0);
      } else {
        var user = $scope.xls_users[index];
        OfferService.create_matching_data_xls(window.offer_id, user.id, user.company_title, user.country_id, $scope.filter).success(function(data) {
          if (data.success) {
            user.xls = data.xls;
            if (index < $scope.xls_users.length - 1) {
              $scope.mass_create_xls(index + 1);
            } else {
              OfferService.send_matching_data(window.offer_id, _.where($scope.tabs[0].users, {
                checked: true
              }), $scope.email_custom_text, $scope.email_recipient).success(function(data) {
                if (data.success) {
                  $scope.sending_matching_data = false;
                  $.fancybox.close();
                }
              });
            }
          }
        });
      }
    };

    $scope.add_users_to_offer_campaign = function() {
      var users = _.where($scope.tabs[0].users, {
        checked: true
      });
      if (users.length === 0) {
        alert('Please select at least one user!');
        return false;
      }
      $scope.adding_users_to_campaign = true;
      OfferService.add_users_to_offer_campaign(window.offer_id, users, $scope.filter).success(function(data) {
        if (data.success)
          $scope.adding_users_to_campaign = false;
      });
    };

    $scope.select2_options = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '300px'
    };

    $scope.show_by_min_quantity = function(user) {
      var min_quantity = parseInt($scope.filter.min_quantity);
      if (!isNaN(min_quantity) && user.items_quantity)
        return user.items_quantity >= min_quantity;
      else
        return true;
    };

    $scope.filter = {
      user_countries: [],
      has_specs: 'all',
      user_group: 'all',
      business_relation: -1,
      pre_min_quality_accuracy: 1,
      pre_min_specs_accuracy: 1,
      min_quality_accuracy: 1,
      min_specs_accuracy: 1,
      specs_method_operator: 2,
      specs_method_percentage: 5,
      specs_method_standard: true,
      specs_method_relative: false,
      specs_method_special: false,
      specs_method_advanced: false,
      specs_matching_accurate: true,
      specs_matching_flexible: true,
      specs_matching_basic_only: false,
      special_matching_method: 0, // 0 = quick, 1 = analytical
      special_matching_cuts: 1,
      special_matching_waste: 2,
      special_matching_range: 2,
      min_quantity: 0
    };
    
    $scope.columns = {
      buyer: true,
      relation: true,
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.offer_id = window.offer_id;
      $scope.is_single_product = window.is_single_product;
      $scope.email_recipient = 'p.tsolpagas@epsilon-paper.com';
      $scope.tinymceOptions = UiService.tinymceOptions();
      $scope.tinymceOptions.height = 100;
      $scope.email_custom_text = '';
    };

    $scope.init();
  }
}

OfferMatching.$inject = ['$scope', '$timeout', 'OfferService', 'UiService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-matching.ctrl.js